import { BadlandMark } from '@/components/BadlandLogo'

import { CampBackdrop } from './CampBackdrop'

/** The full-screen wait while the session is checked: the mark breathing over the land. */
export function CampLoader({ label = 'Loading...' }: { label?: string }) {
  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-[color:var(--bl-canvas)]">
      <CampBackdrop />
      <div className="relative z-10 flex flex-col items-center gap-5">
        <span className="bl-loader-mark relative block">
          <BadlandMark className="h-16 w-16 text-[color:var(--bl-gold)]" />
        </span>
        <span aria-live="polite" className="bl-label">{label}</span>
      </div>
    </div>
  )
}
